export function waitForTimeout(signal: AbortSignal, timeout: number): Promise<null> {
    return new Promise((resolve) => {
        const timeoutId = setTimeout(() => {
            resolve(null)
        }, timeout)

        signal.addEventListener('abort', () => clearTimeout(timeoutId))
    })
}
